import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { MeasureType } from '../types/measure-type.interface';

export const measureTypeDefinition: EntityDefinition<MeasureType> = {
  entityType: 'MeasureType',
  i18nBase: 'entities.measureType',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'common.labels.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'description',
        headerKey: 'common.labels.description',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [
    { field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 3, maxLength: 50 },
    {
      field: 'description',
      labelKey: 'common.labels.description',
      required: false,
      type: 'textarea',
      minLength: 3,
      maxLength: 400,
    },
  ],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: MeasureType) => !entity.isUsed,
      errorMessageKey: 'entities.measureType.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: MeasureType, store) => {
        if (!store) return true;
        const entities = store.getData<MeasureType>('MeasureType')();
        return !entities.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.measureType.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: MeasureType, store) => {
        if (!store) return true;
        const entities = store.getData<MeasureType>('MeasureType')();
        return !entities.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && type.id !== entity.id);
      },
      errorMessageKey: 'entities.measureType.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.measureType.messages.createTitle',
      edit: () => 'entities.measureType.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.measureType.messages.addButton',
      create: () => 'entities.measureType.messages.addButton',
      edit: () => 'entities.measureType.messages.editTitleWithName',
      delete: () => 'entities.measureType.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.measureType.messages.deleteConfirm',
  },
  enableFiltering: true,
};
